export const GENERATE_BROADCAST_CHANNEL_NAME = (studyId: string) => `PRENUVO_FCT_STUDY_${studyId}`;
